import Index from "views/Index.js";
import Profile from "views/auth/Profile.js";
import Login from "views/auth/Login.js";
import ForgotPassword from "views/auth/ForgotPassword.js";
import VerifyOtp from "views/auth/VerifyOtp";
import SetNewPassword from "views/auth/SetNewPassword";
import Verify2FAOtp from "views/auth/Verify2FAOtp";
import UserTable from "views/users/UserTable";
import Rooms from "views/rooms/Rooms";
import RoomDetail from "views/rooms/RoomDetail";
import Moderation from "views/moderation/Moderation";
import Wallet from "views/wallet/Wallet";
import Kyc from "views/kyc/Kyc";
import Reputation from "views/reputation/Reputation";
import Community from "views/community/Community";
import Security from "views/security/Security";
import Logs from "views/logs/Logs";
import AdminRolesTabs from "views/roles/AdminRolesTabs";
import CountryCity from "views/management/CountryCity";
import ReputationTiers from "views/management/ReputationTiers";
import PrivacyPolicy from "views/management/PrivacyPolicy";
import TermsConditions from "views/management/TermsConditions";
import ContactUs from "views/management/ContactUs";
import RoomTypes from "views/management/RoomTypes";
import ReportTypes from "views/management/ReportTypes";
import Creator from "views/management/Creator";
import PromotionPlan from "views/management/PromotionPlan";
import ReferralRewardManagement from "./views/management/Referral";
import WithdrawFundManagement from "views/management/WithdrawFundManagement";
import JudgesDashboard from "views/judges/JudgesDashboard";
import ReputationConfig from "views/management/ReputationConfig";
import AnalyticsDashboard from "views/analytics/AnalyticsDashboard";
import {
  DashboardIcon,
  UserIcon,
  ChatIcon,
  WalletIcon,
  LogsIcon,
  ModerationIcon,
  KycIcon,
  ReputationIcon,
  CommunityIcon,
  SecurityIcon,
  SettingsIcon,
  MapIcon,
  DocumentIcon,
  AgreementIcon,
  PhoneIcon,
  FolderIcon,
  ListIcon,
  PromotionIcon,
  CreatorIcon,
  ReferralIcon,
  WithdrawIcon,
} from "components/Icons";
var routes = [
  {
    path: "/judges-dashboard",
    name: "Judges Dashboard",
    icon: DashboardIcon,
    component: <JudgesDashboard />,
    layout: "/admin",
    role: "judge"
  },
  {
    path: "/index",
    name: "Dashboard",
    icon: <DashboardIcon className="min-w-24 min-h-24" />  ,
     component: <Index />,
    layout: "/admin",
  },
  {
    path: "/analytics-dashboard",
    name: "Analytics & Growth",
    icon: <DashboardIcon className="min-w-24 min-h-24" />,
    component: <AnalyticsDashboard />,
    layout: "/admin",
  },
  {
    path: "/users-list",
    name: "Users",
    icon: <UserIcon className="min-w-24 min-h-24"  />,
    component: <UserTable />,
    layout: "/admin",
  },
  {
    path: "/rooms-chats",
    name: "Rooms & Chats",
    icon: <ChatIcon className="min-w-24 min-h-24"/>,
    component: <Rooms />,
    layout: "/admin",
  },
  {
    path: "/rooms-chats/:id",
    component: <RoomDetail />,
    layout: "/admin",
  },
  {
    path: "/moderation",
    name: "Moderation",
    icon: <ModerationIcon className="min-w-24 min-h-24" />,
    component: <Moderation />,
    layout: "/admin",
  },
  {
    path: "/wallet-payments",
    name: "Wallet & Payments",
    icon: <WalletIcon />,
    component: <Wallet />,
    layout: "/admin",
  },
  {
    path: "/kyc-disputes",
    name: "KYC & Disputes",
    icon: <KycIcon  className="min-w-24 min-h-24"/>,
    component: <Kyc />,
    layout: "/admin",
  },
  {
    path: "/reputation-badges",
    name: "Reputation & Badges",
    icon: <ReputationIcon  className="min-w-24 min-h-24"/>,
    component: <Reputation />,
    layout: "/admin",
  },
  {
    path: "/community-features",
    name: "Community Features",
    icon: <CommunityIcon className="min-w-24 min-h-24" />,
    component: <Community />,
    layout: "/admin",
  },
  {
    path: "/security-tools",
    name: "Security Tools",
    icon: <SecurityIcon className="min-w-24 min-h-24" />,
    component: <Security />,
    layout: "/admin",
  },
  {
    path: "/system-logs",
    name: "System Logs",
    icon: <LogsIcon className="min-w-24 min-h-24" />,
    component: <Logs />,
    layout: "/admin",
  },
  {
    path: "/role-management",
    name: "Role Management",
    icon: <UserIcon  className="min-w-24 min-h-24"/>,
    component: <AdminRolesTabs />,
    layout: "/admin",
  },
  {
    path: "/country-city-management",
    name: "Country & City",
    icon: <MapIcon  className="min-w-24 min-h-24"/>,
    component: <CountryCity />,
    layout: "/admin",
  },
  // {
  //   path: "/reputation-tiers",
  //   name: "Reputation Tiers",
  //   icon: "ni ni-diamond text-warning",
  //   component: <ReputationTiers />,
  //   layout: "/admin",
  // },
  {
    path: "/reputation-config",
    name: "Reputation Config",
    icon: <SettingsIcon className="min-w-24 min-h-24"/>,
    component: <ReputationConfig />,
    layout: "/admin",
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    icon: <DocumentIcon  className="min-w-24 min-h-24"/>,
    component: <PrivacyPolicy />,
    layout: "/admin",
  },
  {
    path: "/terms-conditions",
    name: "Terms & Conditions",
    icon: <AgreementIcon className="min-w-24 min-h-24"/>,
    component: <TermsConditions />,
    layout: "/admin",
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    icon: <PhoneIcon className="min-w-24 min-h-24"/>,
    component: <ContactUs />,
    layout: "/admin",
  },
  {
    path: "/room-types",
    name: "Room Types",
    icon: <FolderIcon className="min-w-24 min-h-24"/>,
    component: <RoomTypes />,
    layout: "/admin",
  },
  {
    path: "/report-types",
    name: "Report Types",
    icon: <ListIcon className="min-w-24 min-h-24"/>,
    component: <ReportTypes />,
    layout: "/admin",
  },
  {
    path: "/promotion-plans",
    name: "Promotion Plan",
    icon: <PromotionIcon className="min-w-24 min-h-24"/>,
    component: <PromotionPlan />,
    layout: "/admin",
  },
  {
    path: "/creator-management",
    name: "Creator Management",
    icon: <CreatorIcon className="min-w-24 min-h-24"/>,
    component: <Creator />,
    layout: "/admin",
  },
  {
    path: "/referral-management",
    name: "Referral Management",
    icon: <ReferralIcon className="min-w-24 min-h-24"/>,
    component: <ReferralRewardManagement />,
    layout: "/admin",
  },
  {
    path: "/withdraw-fund-management",
    name: "Withdraw Fund Management",
    icon: <WithdrawIcon className="min-w-24 min-h-24"/>,
    component: <WithdrawFundManagement />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Profile",
    icon: <UserIcon className="min-w-24 min-h-24"/>,
    component: <Profile />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-lock-circle-open text-warning",
    component: <ForgotPassword />,
    layout: "/auth",
  },
  {
    path: "/verify-otp",
    name: "Verify OTP",
    icon: "ni ni-lock-circle-open text-warning",
    component: <VerifyOtp />,
    layout: "/auth",
  },
  {
    path: "/set-new-password",
    name: "Set new password",
    icon: "ni ni-lock-circle-open text-warning",
    component: <SetNewPassword />,
    layout: "/auth",
  },
  {
    path: "/verify-2fa-otp",
    name: "Verify 2FA",
    icon: "ni ni-lock-circle-open text-info",
    component: <Verify2FAOtp />,
    layout: "/auth",
  }
];

export default routes;
